export const colorsByType = {
  spline: ['#348BE3', '#ED5588', '#3CBD67', '#A55DC7', '#E0A838', '#F2855A'],
  column: ['#A1CDF7', '#348BE3'],
};
